import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
export const Textarea = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {boolean} [props.valid]
 * @param {boolean} [props.disabled]
 * @param {any} [props.className]
 * @param {any} [props.children]
 * @param {string} [props.placeholder]
 * @param {string} [props.title]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function Textarea({
  valid,
  disabled,
  className,
  children,
  ...props
}, ref) {
  const activeClasses = "border-en-gray-600 hover:border-en-gray-900 focus:border-en-yellow-700";
  const validClasses = "focus:border-en-green";
  const invalidClasses = "border-en-red focus:border-en-red hover:border-en-red";
  const disabledClasses = "border-en-gray-600 bg-en-gray-100";

  const hasValidation = () => ![null, undefined].includes(valid);

  const validationStyle = () => {
    if (hasValidation()) {
      return valid ? validClasses : invalidClasses;
    }
  };

  const textareaClasses = classNames(["border rounded-md p-2 caret-en-yellow-700", "focus:outline-none placeholder-en-gray-300"], // don't apply activeStyle if has valid or disabled
  !hasValidation() && !disabled && activeClasses, // don't apply disabledStyle if has valid
  !hasValidation() && disabled && disabledClasses, validationStyle(), className);
  return /*#__PURE__*/React.createElement("textarea", _extends({
    className: textareaClasses,
    ref: ref,
    disabled: disabled
  }, props), children);
});
Textarea.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  valid: PropTypes.bool
};